var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"option-table column-center",attrs:{"descargando":_vm.descargando,"title":_vm.$t('descargar_resultados_calificacion')},on:{"click":_vm.descargar}},[_c('i',{staticClass:"column row-between ais"},[_c('download-doc')],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('descargar_resultados_calificacion')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ebfc32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/descarga-resultados.vue
// module id = null
// module chunks = 